import React from 'react'
import { Grid, Typography } from '@material-ui/core/'
import moment from 'moment'
import './index.scss'

const ReviewMess = ({ img, time, name, goTo, town }) => (
  <Grid className='ReviewBox' onClick={goTo}>
    <Grid className='contentBox'>
      <img className='imgStory' src={img} />
      <Typography className='descText'>
        {town ? `How was your meeting with ${name} from ${town}?` : `How was your meeting with ${name}?`}
      </Typography>
    </Grid>
    <Grid className='dateBox'>
      <Typography className='date'>Date: <span>{moment(+time)?.format('Do of MMM')}</span></Typography>
      <Typography className='time'>Time: <span>{moment(+time).format('h:mm A')}</span></Typography>
    </Grid>
  </Grid>
)

export default ReviewMess
